
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kVysQ", function(module, exports) {

$parcel$export(module.exports, "PERFORMANCE_SUBJECT_linkToPage", () => $35b50a968705ed01$export$c4d483efe8eba686);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_mainLayout", () => $35b50a968705ed01$export$1de09ba64e7728f2);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_manageWatcherDialog", () => $35b50a968705ed01$export$586856ecee8f0723);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigation", () => $35b50a968705ed01$export$51f018e0f9f84a74);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigationFMP", () => $35b50a968705ed01$export$94afb8303c61d07d);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_sideNavigationFMP", () => $35b50a968705ed01$export$fe596581250cd9fc);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigationView", () => $35b50a968705ed01$export$88c949ed1e388f68);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_recentDropdown", () => $35b50a968705ed01$export$1a3cc5086fadf289);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog", () => $35b50a968705ed01$export$b35db70015797a33);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_copyPageTree", () => $35b50a968705ed01$export$5c78998b70cdff69);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_spaceDirectory", () => $35b50a968705ed01$export$1167e4f56227df4c);
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';

});

parcelRegister("4NX9d", function(module, exports) {

$parcel$export(module.exports, "PerformanceEnd", () => $6182ff2f7ce21920$export$c7a09306845216e0);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $9eE57 = parcelRequire("9eE57");
class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $gwFzn.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};

});


//# sourceMappingURL=PageTree.d64d6592.js.map
